module.exports = __webpack_public_path__ + "img/Group154.6ff6649a.svg";